import React from "react";
import "./styles.less";

import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";

import { Footer } from "../../components/FooterV2";
import { Header } from "../../components/Header";

import { ZeroCompliance } from "./ZeroCompliance";
import { ZeroOther } from "./ZeroOther";
import { AuthorizationBanner } from "./AuthorizationBanner";
import { AuthorityQuestion } from "./AuthorityQuestion";
import { AuthorityAdvantage } from "./AuthorityAdvantage";
import { AuthorityFeature } from "./AuthorityFeature";

export const AuthorizationPage = () => {
  const { t } = useTranslation();

  return (
    <div className="zero-trust-page">
      <Helmet>
        <title>
          使用多租户功能，实现多租户的数据隔离与身份管理｜Authing身份云
        </title>
      </Helmet>
      <Header mode="dark" hasNotice />
      <AuthorizationBanner />
      <AuthorityQuestion />
      <AuthorityAdvantage />
      <AuthorityFeature />
      <ZeroCompliance />
      <ZeroOther />
      <Footer />
    </div>
  );
};
